<template>
    <b-dropdown id="day-selection" variant="white" :toggle-class="{'language': true, 'border-danger': invalid}" menu-class="drop-menu" :disabled="disabled">
        <template v-slot:button-content>
            {{ typeof day === 'string' ? day : day[label] }}
            <img class="mr-0" src="@/assets/images/down.svg" alt="down" height="18" width="18" />
        </template>

        <b-dropdown-item
            class="time-menu-item"
            v-for="(option, i) in dayOptions"
            :key="`day${i}`"
            @click="dayChanged(option)"
            :link-class="{'active': option === day, 'time-menu-item d-flex': true}"
        >
            <div class="my-auto" v-if="typeof option === 'string'">
                {{ option }}
            </div>
            <div class="my-auto" v-else>
                {{ option[label] }}
            </div>
        </b-dropdown-item>
    </b-dropdown>
</template>
<script>
import moment from 'moment';

export default {
    props: {
        day: {
            type: [String, Object],
            default: ""
        },
        dayOptions: {
            type: Array,
            default: () => ['Today', 'Yesterday', 'Last week', 'Last month', 'This year', 'All time', 'Custom']
        },
        disabled: {
            type: Boolean,
            default: false
        },
        invalid: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: "DD-MM-YYYY"
        },
        label : {
            type: String
        }
    },
    methods: {
        dayChanged(value) {
            let startDate, endDate;

            let response = {
                startDate: null,
                endDate: null,
                openDatePicker: false,
                day: value
            }

            if(value && typeof value !== 'string') {
                startDate = moment(value.from_time, this.format);
                endDate = moment(value.to_time, this.format);
            } else {
                switch (value) {
                    case 'Today':
                        startDate = moment();
                        endDate = moment();
                        break;
                    case 'Yesterday':
                        startDate = moment().subtract(1, 'days');
                        endDate = moment().subtract(1, 'days');
                        break;
                    case 'Last week':
                        startDate = moment().subtract(1, 'weeks').startOf('week');
                        endDate = moment().subtract(1, 'weeks').endOf('week');
                        break;
                    case 'This week':
                        startDate = moment().startOf('week');
                        endDate = moment().endOf('week');
                        break;
                    case 'Last month':
                        startDate = moment().subtract(1, 'months').startOf('month');
                        endDate = moment().subtract(1, 'months').endOf('month');
                        break;
                    case 'This year':
                        startDate = moment().startOf('year');
                        endDate = moment();
                        break;
                    case 'All time':
                        startDate = moment('2018-01-01T00:00:00.000');
                        endDate = moment();
                        break;
                    case 'Custom':
                        response.openDatePicker = true;
                        break;
                    default:
                        break;
                }
            }
            if(startDate && endDate) {
                startDate.set({ 'hour': 0, 'minute': 0, 'second': 0 });
                endDate.set({ 'hour': 23, 'minute': 59, 'second': 59 });

                response.startDate = new Date(startDate);
                response.endDate = new Date(endDate);
            }

            this.$emit('day-selected', response);
        },
    }
}
</script>

<style scoped>
::v-deep .dropdown-toggle {
  /* overflow-x: scroll; */
}
::v-deep .dropdown-menu {
    max-height: 50vh;
    overflow-y: scroll;
}
</style>